<template>
<div class="s3">
  <div v-if="!value">
    <div v-if="status === 'preupload'">
      <span class="text">送信準備中...</span>
    </div>
    <div v-else-if="status === 'uploading'" class="ui indicating progress" data-percent="0">
      <div class="bar"></div>
      <div class="label">{{ progress }}%</div>
    </div>
    <input v-else type="file" :accept="accept" @change="attach($event.target)" />
  </div>
  <div v-else>
    <span v-if="value && value.mime_type && value.mime_type === 'application/pdf'" class="pdfIcon">
      <i class="fas fa-file-pdf"></i>
    </span>
    <img v-else-if="value && value.urls.preview" :src="value.urls.preview">
    <img v-else-if="value && value.urls.small" :src="value.urls.small">
    <span class="filename" :title="value.original_file_name">{{ value.original_file_name }}</span>
    <button class="ui mini negative button" type="button" @click="clear()">削除</button>
  </div>
</div>
</template>

<script>
export default {
    props: {
        value: {
            // TODO: specify Nullable Object
            // type: Object,
            required: true
        },
        accept: {
            required: false,
            type: String,
            default: 'image/*'
        }
    },
    data: function() {
        return {
            form: this.createForm(this.value),
            status: null,
            progress: 0,
        };
    },
    methods: {
        apply: function(value) {
            this.status = null;
            // TODO: propを直接編集すると警告が出るので修正したい
            this.value = value;
            this.$emit('input', value);
        },
        attach: function(target) {
            var file = target.files[0];
            this.status = 'preupload';
            this.createForm({
                file: file,
                original_file_name: file.name,
                mime_type: file.type || 'application/octet-stream',
                size: file.size,
            }).post('/api/s3/reserve', function(response) {
                var url = response.data.presigned_post.url;
                var presigned = response.data.presigned_post.fields;
                var reserved = response.data.reserved;

                this.progress = 0;
                this.status = 'uploading';
                var formData = new FormData();
                for (var name in presigned) {
                    formData.append(name, presigned[name]);
                }
                formData.append('file', file);
                var self = this;
                this.uploader = $.ajax({
                    async: true,
                    url: url,
                    type: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                    crossDomain: true,
                    xhr: function() {
                        var xhr = $.ajaxSettings.xhr();
                        if (xhr.upload) {
                            xhr.upload.addEventListener('progress', function(event) {
                                if (event.loaded > 0) {
                                    self.progress = Math.round(event.loaded / event.total * 100);
                                    $('.ui.progress', self.$el).progress({percent: self.progress})
                                }
                            }, false);
                        }
                        return xhr;
                    }
                });
                this.uploader.then(function() {
                    // 画像サイズが小さいとアニメーションが一瞬で終わってしまって完了したかどうかよくわからないので500ms待ち
                    setTimeout(function() {
                        this.apply(reserved);
                    }.bind(this), 500);
                }.bind(this), function() {
                    this.clear();
                }.bind(this));
            }.bind(this));
        },
        clear: function() {
            this.apply(null);
        }
    }
};
</script>
